import {FC} from 'react';
import {keys, map, size, unset} from 'lodash';
import {observer} from 'mobx-react';
import cx from 'classnames';

import Port from './Port';
import {SpeedType} from '../types';

import './PortsCount.less';

type PortsCountProps = {
  portsBySpeed: Record<string, number>;
  onClick?: (speed: SpeedType, speedString?: string) => void;
  selectedSpeed?: string | null;
  error?: boolean;
  showEmpty?: boolean;
  usedCount?: number;
  limitBy?: string;
}

const PortsCount: FC<PortsCountProps> = ({portsBySpeed, onClick, selectedSpeed, error, showEmpty, usedCount = 0,
  limitBy}) => {
  const classNames = cx('re-ports-count', {error});

  const ports = size(portsBySpeed) ? {...portsBySpeed} : (showEmpty ? {'': 0} : {});
  if (selectedSpeed && !ports[selectedSpeed]) {
    ports[selectedSpeed] = 0;
    unset(ports, '');
  }

  return (
    <div className={classNames}>
      {
        map(
          keys(ports).sort(),
          (speedString) => {
            const amount = ports[speedString];
            const portsAvailable = usedCount > 0 || amount > 0;
            const selected = !!selectedSpeed && selectedSpeed === speedString && portsAvailable;
            return (showEmpty || !!amount) &&
              <Port
                key={speedString}
                speedString={portsAvailable ? speedString : null}
                amount={amount}
                onClick={amount ? onClick : undefined}
                selected={selected}
                disabled={!!limitBy && limitBy !== speedString}
              />;
          }
        )
      }
    </div>
  );
};

export default observer(PortsCount);
